import { useFormikContext } from 'formik';
import React from 'react';

import AutocompleteField from '@components/Form/AutocompleteField';
import DropdownField from '@components/Form/DropdownField';
import { useEntitiesCreate } from '@hooks';
import { autocompleteEntities } from '@utils/backend-api/entities';
import {
  ENTITY_TYPE_ORGANIZATION_INDUSTRY,
  ENTITY_WORD_TYPE_COMMON,
  ORGANIZATION_INDUSTRY_OPTIONS,
  PROFILE_FIELD_OTHER_VALUE,
} from '@utils/backend-api/profileSettings';

import { StepProfileFormProps } from '../StepProfile';

interface IndustryFieldsProps {
  isRequired: boolean;
  silenceToast?: boolean;
}

const IndustryFields = ({ isRequired, silenceToast = false }: IndustryFieldsProps) => {
  const { values } = useFormikContext<StepProfileFormProps>();
  const { mutateAsync: createEntityAsync } = useEntitiesCreate(silenceToast);
  return (
    <>
      <DropdownField
        name="industry"
        options={ORGANIZATION_INDUSTRY_OPTIONS}
        label={isRequired ? 'Industry*' : 'Industry'}
        placeholder="Select"
        isClearable={false}
        scrollIntoView
      />
      {values.industry.value === PROFILE_FIELD_OTHER_VALUE && (
        <div className="mt-4">
          <AutocompleteField
            className="mt-4"
            name="customIndustry"
            fetchMethod={(value) =>
              autocompleteEntities({
                fragment: value,
                entity_type: ENTITY_TYPE_ORGANIZATION_INDUSTRY,
              })
            }
            createMethod={(value) =>
              createEntityAsync({
                name: value,
                entity_type: ENTITY_TYPE_ORGANIZATION_INDUSTRY,
                word_type: ENTITY_WORD_TYPE_COMMON,
              })
            }
          />
        </div>
      )}
    </>
  );
};

export default IndustryFields;
